import { render, staticRenderFns } from "./SocialLoginModal.vue?vue&type=template&id=2a701cd0&"
import script from "./SocialLoginModal.vue?vue&type=script&lang=js&"
export * from "./SocialLoginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports